import $ from 'jquery';
import 'bootstrap/js/transition';
import 'bootstrap/js/dropdown';
import 'bootstrap/js/collapse';
import Widgets from 'js-widget-hooks';


Widgets.register('events-radius-change', function (elem) {
    $(elem).find('a').click(function (e) {
        const root = $(elem).parents('.event-box');
        e.preventDefault();
        root.find('.frame').append('<div class="overlay in"></div>');
        root.load($(this).data('href'), function () {
            Widgets.init();
        });
    })
});